<template>
  <div>
    <w-input :model="schema.mdokCaseId" @input="loadDocumentName(schema.mdokCaseId.$model, 'mdok/getCaseName')" />

    <div v-if="schema.caseName.$model" class="form-group col-md-12">
      <p>
        Wybrano sprawę: <b>{{ schema.caseName.$model }}</b>
      </p>
    </div>
  </div>
</template>

<script>
import { components } from '@witkac/bootstrap4-components';

import { mdokDocumentMixin } from '@/mixins/mdokDocument';

// @vuese
// Formularz potwierdzania
export default {
  components,
  mixins: [mdokDocumentMixin],

  props: {
    // schema
    schema: { type: Object, required: true }
  },

  methods: {
    afterNameGet(name) {
      this.schema.caseName.$setData(name);
    }
  }
};
</script>
